






































































import { Prop, Component, Vue } from 'vue-property-decorator'
import { TypeformResponse } from '@/api/model/typeform/typeform-response'
import { TypeformResponseAPI } from '@/api/backend-client'
import Relatie from '@/views/Typeform/Responses/Detail/Relatie.vue'
import WonenObject from '@/views/Typeform/Responses/Detail/WonenObject.vue'
import Answers from '@/views/Typeform/Responses/Detail/Answers.vue'
import Agenda from '@/views/Typeform/Responses/Detail/Agenda.vue'

@Component({
    components: {
        Agenda,
        Answers,
        WonenObject,
        Relatie,
    },
})
export default class TypeformResponsesDetail extends Vue {
    @Prop({ required: true }) responseId!: string
    loading: boolean = false
    response: TypeformResponse = null

    async created(): Promise<void> {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.response = await TypeformResponseAPI.get(this.responseId)
        this.loading = false
    }

    get routeToList() {
        return {
            name: 'typeform_responses',
        }
    }
}
